import { ROUTES } from '../../constants/routes';
import { ACCESS } from '../../constants/authz';
import { canAccess } from '../../authorization/canAccess';

/** @typedef {{ id: string, path: string, access: import('../../authorization/types/authz.types').AuthzRequirement }} RouteRegistryEntry */

/** @type {ReadonlyArray<RouteRegistryEntry>} */
export const ROUTE_REGISTRY = Object.freeze([
  { id: 'dashboard.hub', path: ROUTES.DASHBOARD.HUB, access: ACCESS.PUBLIC_AUTHENTICATED },

  { id: 'features.intervene', path: ROUTES.FEATURES.INTERVENE, access: ACCESS.INTERVENE_VIEW },
  { id: 'features.analytics', path: ROUTES.FEATURES.ANALYTICS, access: ACCESS.ANALYTICS_VIEW },
  { id: 'features.analytics.builder', path: ROUTES.FEATURES.ANALYTICS_BUILDER, access: ACCESS.ANALYTICS_VIEW },
  { id: 'features.analytics.builder.edit', path: ROUTES.FEATURES.ANALYTICS_BUILDER_EDIT, access: ACCESS.ANALYTICS_VIEW },
  { id: 'features.analytics.report', path: ROUTES.FEATURES.ANALYTICS_REPORT, access: ACCESS.ANALYTICS_VIEW },
  { id: 'features.whatsapp.templates.create', path: ROUTES.FEATURES.WHATSAPP_TEMPLATES_CREATE, access: ACCESS.MESSAGE_TEMPLATE_CREATE },
  { id: 'features.whatsapp.templates.edit', path: ROUTES.FEATURES.WHATSAPP_TEMPLATES_EDIT, access: ACCESS.MESSAGE_TEMPLATE_UPDATE },
  { id: 'features.whatsapp.templates.users', path: ROUTES.FEATURES.WHATSAPP_TEMPLATES_USERS, access: ACCESS.WHATSAPP_TEMPLATE_PERFORMANCE },
  { id: 'features.whatsapp.templates.details', path: ROUTES.FEATURES.WHATSAPP_TEMPLATES_DETAILS, access: ACCESS.WHATSAPP_TEMPLATE_PERFORMANCE },
  { id: 'features.whatsapp.templates.list', path: ROUTES.FEATURES.WHATSAPP_TEMPLATES, access: ACCESS.WHATSAPP_TEMPLATES_VIEW },
  { id: 'features.whatsapp.templates.queue', path: ROUTES.FEATURES.WHATSAPP_TEMPLATE_QUEUE, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'features.whatsapp.templates.base', path: ROUTES.FEATURES.WHATSAPP_TEMPLATES_BASE, access: ACCESS.WHATSAPP_TEMPLATES_VIEW },
  { id: 'features.whatsapp.optin', path: ROUTES.FEATURES.WHATSAPP_OPTIN, access: ACCESS.WHATSAPP_OPTIN },
  { id: 'features.whatsapp.waba.details', path: ROUTES.FEATURES.WHATSAPP_WABA_DETAILS, access: ACCESS.WHATSAPP_WABA },
  { id: 'features.whatsapp.waba', path: ROUTES.FEATURES.WHATSAPP_WABA_APPS, access: ACCESS.WHATSAPP_WABA },
  { id: 'features.whatsapp.meta', path: ROUTES.FEATURES.WHATSAPP_META_SIGNUP, access: ACCESS.WHATSAPP_WABA },
  { id: 'features.flow.builder', path: ROUTES.FEATURES.FLOW_BUILDER, access: ACCESS.FLOW_BUILDER },
  { id: 'features.flow.schedule', path: ROUTES.FEATURES.FLOW_SCHEDULE, access: ACCESS.FLOW_BUILDER },
  { id: 'features.flow.list', path: ROUTES.FEATURES.FLOW_LIST, access: ACCESS.FLOW_VIEW },
  { id: 'features.sms.send', path: ROUTES.FEATURES.SMS_SEND, access: ACCESS.SMS_TEMPLATE_SEND },
  { id: 'features.sms.create', path: ROUTES.FEATURES.SMS_CREATE, access: ACCESS.SMS_TEMPLATE_CREATE },
  { id: 'features.sms.edit', path: ROUTES.FEATURES.SMS_EDIT, access: ACCESS.SMS_TEMPLATE_UPDATE },
  { id: 'features.sms.list', path: ROUTES.FEATURES.SMS_LIST, access: ACCESS.SMS_TEMPLATES_VIEW },
  { id: 'features.sms.logs', path: ROUTES.FEATURES.SMS_LOGS, access: ACCESS.SMS_LOGS_VIEW },
  { id: 'features.datasets', path: ROUTES.FEATURES.DATASETS, access: ACCESS.DATASETS_VIEW },
  { id: 'features.leadWebForm', path: ROUTES.FEATURES.LEAD_WEB_FORM, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'features.opsVerify', path: ROUTES.FEATURES.OPS_VERIFY, access: ACCESS.SUPER_ADMIN_ONLY },

  { id: 'management.profileManagement', path: ROUTES.MANAGEMENT.PROFILE_MANAGEMENT, access: ACCESS.PROFILE_MANAGEMENT_VIEW },
  { id: 'management.profileList', path: ROUTES.MANAGEMENT.PROFILE_LIST, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'management.userManagement', path: ROUTES.MANAGEMENT.USER_MANAGEMENT, access: ACCESS.USER_MANAGEMENT_VIEW },
  { id: 'management.userCreate', path: ROUTES.MANAGEMENT.USER_CREATE, access: ACCESS.USER_CREATE },
  { id: 'management.userList', path: ROUTES.MANAGEMENT.USER_LIST, access: ACCESS.USER_MANAGEMENT_VIEW },
  { id: 'management.license', path: ROUTES.MANAGEMENT.LICENSE, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'management.organisationList', path: ROUTES.MANAGEMENT.ORGANISATION_LIST, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'management.organisationOnboard', path: ROUTES.MANAGEMENT.ORGANISATION_ONBOARD, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'management.organisationOnboarding', path: ROUTES.MANAGEMENT.ORGANISATION_ONBOARDING, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'management.organisationMapping', path: ROUTES.MANAGEMENT.ORGANISATION_MAPPING, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'management.updateAddress', path: ROUTES.MANAGEMENT.UPDATE_ADDRESS, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'management.updateGst', path: ROUTES.MANAGEMENT.UPDATE_GST, access: ACCESS.SUPER_ADMIN_ONLY },

  { id: 'campaign.decisionBoard', path: ROUTES.CAMPAIGN.DECISION_BOARD, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'campaign.list', path: ROUTES.CAMPAIGN.LIST, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'campaign.checklist', path: ROUTES.CAMPAIGN.CHECKLIST, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'campaign.businessFunctions', path: ROUTES.CAMPAIGN.BUSINESS_FUNCTIONS, access: ACCESS.BUSINESS_FUNCTIONS_ACCESS },

  { id: 'records.leadForms', path: ROUTES.LEGACY.RECORDS_BASE, access: ACCESS.WORKSPACE_LEAD_FORMS },
  { id: 'legacy.records', path: ROUTES.LEGACY.RECORDS, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.reporting', path: ROUTES.LEGACY.REPORTING, access: ACCESS.REPORTING_VIEW },
  { id: 'legacy.supplierBaseType', path: ROUTES.LEGACY.SUPPLIER_BASE_TYPE, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.supplierType', path: ROUTES.LEGACY.SUPPLIER_TYPE, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.supplierList', path: ROUTES.LEGACY.SUPPLIER_LIST, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.inventoryBase', path: ROUTES.LEGACY.INVENTORY_BASE, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.inventoryList', path: ROUTES.LEGACY.INVENTORY_LIST, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.bookingBase', path: ROUTES.LEGACY.BOOKING_BASE, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.bookingTemplate', path: ROUTES.LEGACY.BOOKING_TEMPLATE, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.bookingCampaigns', path: ROUTES.LEGACY.BOOKING_CAMPAIGNS, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.ai', path: ROUTES.LEGACY.AI, access: ACCESS.AI_DASHBOARD_VIEW },
  { id: 'legacy.vector', path: ROUTES.LEGACY.VECTOR, access: ACCESS.VECTOR_DATABASE_VIEW },
  { id: 'legacy.ecommerceOrders', path: ROUTES.LEGACY.ECOMMERCE_ORDERS, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.ecommerceListing', path: ROUTES.LEGACY.ECOMMERCE_LISTING, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.ecommerceFlow', path: ROUTES.LEGACY.ECOMMERCE_FLOW, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.tools', path: ROUTES.LEGACY.TOOLS, access: ACCESS.TOOLS_VIEW },
  { id: 'legacy.machadaloStudio', path: ROUTES.LEGACY.MACHADALO_STUDIO, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.licenseDashboard', path: ROUTES.LEGACY.LICENSE_DASHBOARD, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.onboarding', path: ROUTES.LEGACY.ONBOARDING, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'legacy.studentConceptBuilder', path: ROUTES.LEGACY.STUDENT_CONCEPT_BUILDER, access: ACCESS.EDTECH_CONCEPT_BUILDER },
  { id: 'legacy.studentCreateTest', path: ROUTES.LEGACY.STUDENT_CREATE_TEST, access: ACCESS.EDTECH_PRACTICE_TEST },
  { id: 'legacy.studentKnowledgeMap', path: ROUTES.LEGACY.STUDENT_KNOWLEDGE_MAP, access: ACCESS.EDTECH_KNOWLEDGE_MAP },
  { id: 'legacy.studentPlatform', path: ROUTES.LEGACY.STUDENT_PLATFORM, access: ACCESS.EDTECH_SYLLABUS_BUILDER },
  { id: 'legacy.studentPerformance', path: ROUTES.LEGACY.STUDENT_PERFORMANCE, access: ACCESS.EDTECH_PERFORMANCE_MAP },
  { id: 'legacy.studentNotices', path: ROUTES.LEGACY.STUDENT_NOTICES, access: ACCESS.EDTECH_ACADEMIC_INFO },
  { id: 'legacy.studentQuestionBank', path: ROUTES.LEGACY.STUDENT_QUESTION_BANK, access: ACCESS.EDTECH_QUESTION_BANK },
  { id: 'legacy.settings', path: ROUTES.LEGACY.SETTINGS, access: ACCESS.SUPER_ADMIN_ONLY },
  { id: 'dashboard.parent', path: ROUTES.DASHBOARD.PARENT, access: ACCESS.EDTECH_PARENT_DASHBOARD },
  { id: 'dashboard.teacher', path: ROUTES.DASHBOARD.TEACHER, access: ACCESS.EDTECH_TEACHER_DASHBOARD },
]);

/**
 * Longest-prefix match for route access lookup.
 * @param {string} pathname
 * @returns {RouteRegistryEntry|null}
 */
export function getRouteAccessByPath(pathname) {
  if (!pathname) return null;

  const normalized = pathname.split('?')[0].replace(/\/+$/, '') || '/';
  const sorted = [...ROUTE_REGISTRY].sort((a, b) => b.path.length - a.path.length);

  for (const entry of sorted) {
    const base = entry.path.replace(/\/+$/, '');
    if (normalized === base || normalized.startsWith(`${base}/`)) {
      return entry;
    }
  }

  return null;
}

/**
 * @param {string} pathname
 * @param {import('../../authorization/types/authz.types').AuthzContext} authz
 */
export function isPathAllowed(pathname, authz) {
  if (!authz?.isAuthzV2Enabled || authz?.isFullAccess) {
    return true;
  }

  const entry = getRouteAccessByPath(pathname);
  if (!entry) {
    return false;
  }

  return canAccess(authz, entry.access);
}
